import React, { useState, useEffect, useContext } from 'react'
import useApi from 'hooks/useApi'
import messages from './messages'
import { FormattedTime, FormattedDate, FormattedMessage, useIntl } from 'react-intl'
import { useKeyboardShortcut } from '@arnsbogroup/react-voicearchive/lib/hooks'
import { DataTable } from '@arnsbogroup/react-voicearchive'

const Span = ({ children }) => <span>{ children }</span>
const DateSpan = ({ children }) => <span className="space-x-2">
  <FormattedDate value={new Date(children * 1000)} /> <FormattedTime value={new Date(children * 1000)} />
</span>

const LogPane = ({ match, location }) => {
  const { formatMessage } = useIntl()
  const [entries] = useApi(`/actionlog/forOrder.json?orderId=${match.params.orderId}`)

  return (
    <DataTable
      className="w-full h-full table-auto"
      entries={entries}
      head={{
        crdate: { label: 'Created On' },
        username: { label: 'User' },
        taskId: { label: 'Task ID' },
        taskName: { label: 'Task' },
        message: { label: 'Message' },
      }}
      body={{
        crdate: DateSpan,
        username: Span,
        taskId: Span,
        taskName: Span,
        message: Span,
      }}
    />
  )
}

export default LogPane
